// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { calendarLines16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-calendar-lines': IconCalendarLines;
    }
}

/**
 * The icon component for the 'calendarLines' icon
 */
export class IconCalendarLines extends IconSvg {
    public constructor() {
        super(calendarLines16X16);
    }
}

registerIconSvg('icon-calendar-lines', IconCalendarLines);
export const iconCalendarLinesTag = 'nimble-icon-calendar-lines';
